// extracted by mini-css-extract-plugin
export default {"resume":"SizeMediumStateDefaultSt_resume__+2SGy","sizemediumStatedefaultSt":"SizeMediumStateDefaultSt_sizemediumStatedefaultSt__zM2yt"};